export interface NotificationProps {
	title?: string;
	type?: NotificationEnum;
	description?: string;
	duration?: number;
	show?: boolean;
}

export enum NotificationEnum {
	Danger = 'danger',
	Warning = 'warning',
	Success = 'success',
	Info = 'info',
	Error = 'Error'
}
